import { render, staticRenderFns } from "./ScreenMorfologica1Trimestre.vue?vue&type=template&id=57b3e539&scoped=true&"
import script from "./ScreenMorfologica1Trimestre.vue?vue&type=script&lang=js&"
export * from "./ScreenMorfologica1Trimestre.vue?vue&type=script&lang=js&"
import style0 from "./ScreenMorfologica1Trimestre.vue?vue&type=style&index=0&id=57b3e539&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b3e539",
  null
  
)

export default component.exports